import * as service from './service'

export default {
  namespace: 'helmetAuditHelmetAuditHome',
  state: {
    demoData: {}
  },
  effects: {
    * imageCheck ({ payload }, { call, put }) {
      const res = yield call(service.imageCheck, payload)
      return res.data
    },
    reducers: {
      save (state, { payload }) {
        return { ...state, ...payload }
      }
    }
  }
}
